import { Pipe, PipeTransform, inject } from '@angular/core';
import { ZOOM_LEVEL } from '@wilson/interfaces';
import { DateTimeFormat } from '@wilson/utils';
import { format } from 'date-fns';
import { DateRangeService } from './date-range.service';

@Pipe({
  name: 'isDateHighlighted',
  standalone: true,
})
export class IsDateHighlightedPipe implements PipeTransform {
  private dateRangeService = inject(DateRangeService);

  transform(
    selectedDate: Date | null,
    current: Date,
    zoomLevel: ZOOM_LEVEL | null,
  ): boolean {
    if (selectedDate && zoomLevel) {
      const datesToHighlight = this.dateRangeService.calculateDateRange(
        zoomLevel,
        selectedDate,
      );
      const formattedCurrentDate = format(
        current,
        DateTimeFormat.DatabaseDateFormat,
      );
      return datesToHighlight.includes(formattedCurrentDate);
    } else {
      return false;
    }
  }
}
